export default "__VITE_ASSET__BMTYo_2N__"